import React, { 
    useState, 
    useEffect 
} from 'react'

import Navbar from '../../Components/Navbar/Navbar'
import Graph from '../../Components/Graph'

import { 
    Person,
    AddCircle,
 } from '@mui/icons-material';

import { 
    Layout,
    Col, 
    Row,
    Button,
    Space,
    Modal,
    // Button,
    // Dropdown, 
    // Space,
} from 'antd';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { useNavigate } from "react-router-dom"
import { 
    // formatAmount, 
    formatDateTime, 
    formatYMD, 
    getName 
} from '../../Utils/Common';

const Dashboard = () => {
    const navigate = useNavigate();
    const [currentDateTime, setCurrentDateTime] = useState(new Date());
    const current_date = new Date();
    const current_year = current_date.getFullYear();
    const [isBirthday, setIsBirthday] = useState(false);
    const [statusData, setStatusData] = useState([]);
    const [memberDetails, setMemberDetails] = useState([]);
    const [graphDetails, setGraphDetails] = useState([]);

    async function fetchStatusData() {
        const response = await UseGetRequest("dashboard/get_status_counts");
        if (response?.data) {
          setStatusData(response?.data);
        } else {
          setStatusData([])
        }
    }
    async function fetchMemberData() {
        const response = await UseGetRequest("dashboard/get_counts", {date: formatYMD(current_date)});
        if (response?.data) {
          setMemberDetails(response?.data);
        } else {
          setMemberDetails([])
        }
    }
    async function fetchGraphData() {
        const response = await UseGetRequest("dashboard/get_monthly_member_counts", {year: current_year});
        if (response?.data) {
          setGraphDetails(response?.data);
        } else {
          setGraphDetails([])
        }
    }
    useEffect(() => {
      const intervalId = setInterval(() => {
        setCurrentDateTime(new Date());
      }, 1000);
  
      // Clear the interval when the component unmounts or when the dependency array changes
      return () => clearInterval(intervalId);
    }, []);

    useEffect(() => {
        fetchStatusData();
        fetchMemberData();
        fetchGraphData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Layout className='page'>
            <Navbar navKey={'dashboard'}/>
            <Layout className='custom-padding dashboard'>
                <Row className='dashboard-header mb-4'>
                    <Col
                        xs={24} sm={24} md={12} lg={12} xl={12}
                        className='highlight-font'
                    >
                        <Person className='highlight-font'/> Hi! Welcome, {getName()}
                    </Col>
                    <Col 
                        xs={24} sm={24} md={12} lg={12} xl={12}
                        className='dashboard-header-two'
                    >
                        {formatDateTime(currentDateTime)}
                    </Col>
                </Row>
                <Row>
                    <Col
                        xs={24} sm={24} md={18} lg={18} xl={18}
                    >
                        <Row>
                            <Col
                                xs={24} sm={24} md={8} lg={8} xl={8}
                            >
                                <Row 
                                    className='highlight-box m-2'
                                >
                                    <Col span={10} className='center'>
                                        ACTIVE
                                    </Col>
                                    <Col span={14} className='center num-font'>
                                        {statusData?.active_count}
                                    </Col>
                                </Row>
                            </Col>
                            <Col 
                                xs={24} sm={24} md={8} lg={8} xl={8}
                            >
                                <Row 
                                    className='highlight-box m-2'
                                >
                                    <Col span={10} className='center'>
                                        PENDING
                                    </Col>
                                    <Col span={14} className='center num-font'>
                                        {statusData?.pending_count}
                                    </Col>
                                </Row>
                            </Col>
                            <Col 
                                xs={24} sm={24} md={8} lg={8} xl={8}
                            >
                                <Row 
                                    className='highlight-box m-2'
                                >
                                    <Col span={10} className='center'>
                                        ASSIGNED
                                    </Col>
                                    <Col span={14} className='center num-font'>
                                        {statusData?.assigned_count}
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row className='center'>
                            <Col
                                xs={24} sm={24} md={8} lg={8} xl={8}
                            >
                                <Row 
                                    className='highlight-box m-2'
                                >
                                    <Col span={10} className='center'>
                                        DELINQUENT
                                    </Col>
                                    <Col span={14} className='center num-font'>
                                        {statusData?.delinquent_count}
                                    </Col>
                                </Row>
                            </Col>
                            <Col 
                                xs={24} sm={24} md={8} lg={8} xl={8}
                            >
                                <Row 
                                    className='highlight-box m-2'
                                >
                                    <Col span={10} className='center'>
                                        CANCELLED
                                    </Col>
                                    <Col span={14} className='center num-font'>
                                        {statusData?.cancelled_count}
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <Col
                                xs={24} sm={24} md={24} lg={24} xl={24}
                            >
                                <Row className='center'>
                                    MEMBERS
                                </Row>
                                <Row>
                                    <Graph data={graphDetails?.member_monthly_count}/>
                                </Row>
                            </Col>
                        </Row>
                    </Col>   
                    <Col 
                        xs={24} sm={24} md={6} lg={6} xl={6}
                    >
                        <Row 
                            className='add-box m-2 mb-4 center'
                        >
                            <Col span={12}>
                                <Space direction='vertical' className='center'>
                                    <b>ADD MEMBER</b>
                                    <Button className='dashboard-btn' onClick={() => navigate('/member/add')}>
                                        <AddCircle/>
                                    </Button>
                                </Space>
                            </Col>
                            <Col span={12}>
                                <Space direction='vertical' className='center' onClick={() => navigate('/corporate',  { state: { addCorporate: true } })}>
                                    <b>ADD CORPORATE</b>
                                    <Button className='dashboard-btn'>
                                        <AddCircle/>
                                    </Button>
                                </Space>                            
                            </Col>
                        </Row>
                        <Row 
                            className='side-box m-2 mb-4 center cursor'
                            onClick={() => navigate('/member')}
                        >
                            <Col span={24}>
                                <Row>
                                    <Col span={24} className='center'>
                                        MEMBER
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={24} className='center num-font'>
                                        {memberDetails?.member_count}
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row 
                            className='side-box m-2 mb-4 center cursor'
                            onClick={() => navigate('/corporate')}
                        >
                           <Col span={24}>
                                <Row>
                                    <Col span={24} className='center'>
                                        CORPORATE
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={24} className='center num-font'>
                                        {memberDetails?.corporate_count}
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row 
                            className='side-box m-2 center cursor'
                            onClick={() => setIsBirthday(true)}
                        >
                           <Col span={24}>
                                <Row>
                                    <Col span={24} className='center'>
                                        BIRTHDAY
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={24} className='center num-font'>
                                        {memberDetails?.birthday_count}
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Modal
                    title="HAPPY BIRTHDAY(s)"
                    open={isBirthday}
                    onCancel={() => setIsBirthday(false)}
                    maskClosable={false}
                    footer={null}             
                >
                    {memberDetails?.birthday_members?.map((data, index) => (
                        <div key={index}>- {data.member_name}</div>
                    ))}
                </Modal>

            </Layout>
        </Layout>
    )
}

export default Dashboard
